import { render, staticRenderFns } from "./ScoreEdit.vue?vue&type=template&id=3a2a3694"
import script from "./ScoreEdit.vue?vue&type=script&lang=js"
export * from "./ScoreEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports